// Auto-generated JS wrapper for zapier.md theme content.
// This allows CRA to import the theme as a plain string without raw-loader.

const zapierThemeContent = `---
version: "1.0"
name: "Sunrise"
description: "Warm, energetic orange theme inspired by Zapier's brand identity — bold and inviting."

colors:
  primary: "#ff4f00"
  on-primary: "#FFFFFF"
  ink: "#1A1A2E"
  ink-soft: "#2C2C54"
  body: "#4A4A6A"
  body-mid: "#7B7B9B"
  mute: "#C5C6D0"
  canvas: "#fffefb"
  canvas-soft: "#FFF5EB"
  error: "#dc3545"

typography:
  display-xl:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "56px"
    fontWeight: 700
    lineHeight: "56px"
  display-lg:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "48px"
    fontWeight: 700
    lineHeight: "52px"
  display-md:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "36px"
    fontWeight: 600
    lineHeight: "40px"
  display-sub-md:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "28px"
    fontWeight: 600
    lineHeight: "32px"
  display-sub-sm:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "24px"
    fontWeight: 600
    lineHeight: "28px"
  display-xs:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "20px"
    fontWeight: 600
    lineHeight: "24px"
  body-lg:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "18px"
    fontWeight: 400
    lineHeight: "28px"
  body-md:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "16px"
    fontWeight: 400
    lineHeight: "24px"
  body-sm:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "14px"
    fontWeight: 400
    lineHeight: "20px"
  body-sm-strong:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "14px"
    fontWeight: 600
    lineHeight: "20px"
  caption:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "12px"
    fontWeight: 400
    lineHeight: "16px"
  button-md:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "16px"
    fontWeight: 600
    lineHeight: "24px"
  button-sm:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "14px"
    fontWeight: 600
    lineHeight: "20px"
  eyebrow-uppercase:
    fontFamily: "Inter, system-ui, sans-serif"
    fontSize: "12px"
    fontWeight: 500
    lineHeight: "16px"
    letterSpacing: "1.5px"
    textTransform: "uppercase"

rounded:
  none: "0px"
  sm: "6px"
  md: "12px"
  pill: "9999px"
  full: "50%"

spacing:
  xxs: "2px"
  xs: "4px"
  sm: "8px"
  md: "12px"
  lg: "16px"
  xl: "24px"
  2xl: "32px"
  3xl: "48px"
  4xl: "64px"

components:
  nav-bar:
    bg: "{colors.canvas}"
    text: "{colors.ink}"
    border: "{colors.mute}"
  nav-link:
    text: "{colors.body}"
    activeText: "{colors.primary}"
    activeBg: "{colors.canvas-soft}"
    hoverText: "{colors.ink}"
  button-primary:
    bg: "{colors.primary}"
    text: "{colors.on-primary}"
    radius: "{rounded.md}"
    padding: "{spacing.md} {spacing.xl}"
  button-secondary:
    bg: "{colors.canvas-soft}"
    text: "{colors.ink}"
    radius: "{rounded.md}"
    padding: "{spacing.md} {spacing.xl}"
  button-tertiary:
    bg: "transparent"
    text: "{colors.primary}"
    radius: "{rounded.md}"
    padding: "{spacing.md} {spacing.xl}"
  button-text:
    bg: "transparent"
    text: "{colors.primary}"
    radius: "0px"
    padding: "0px"
  text-input:
    bg: "{colors.canvas}"
    text: "{colors.ink}"
    border: "{colors.mute}"
    radius: "{rounded.sm}"
    padding: "{spacing.md} {spacing.lg}"
  card-content:
    bg: "{colors.canvas}"
    text: "{colors.ink}"
    radius: "{rounded.md}"
    padding: "{spacing.xl}"
    border: "{colors.mute}"
  footer:
    bg: "{colors.ink}"
    text: "{colors.canvas}"
---

# Zapier Theme

A warm, energetic orange theme inspired by Zapier's brand identity.
`;

export default zapierThemeContent;
